import type { OptimizeState} from './optimize.model';
import {initialState} from './optimize.model';
import type {Action} from '@ngrx/store';
import { createReducer, on} from '@ngrx/store';
import {experimentEvent} from './optimize.actions';

export const OPTIMIZE_FEATURE_KEY = 'optimize';
export interface OptimizePartialState {
  readonly [OPTIMIZE_FEATURE_KEY]: OptimizeState;
}

const _optimizeReducer = createReducer<OptimizeState>(
  initialState,
  on(experimentEvent, (state, { payload: { name, value } }) => ({
    ...state,
    experiments: {
      ...state.experiments,
      [name]: { value }
    }
  }))
);

export function optimizeReducer(state: OptimizeState, action: Action) {
  return _optimizeReducer(state, action);
}
